import { defineComponent, createVNode, createTextVNode, resolveComponent, PropType, nextTick, VNode, getCurrentInstance, onMounted} from 'vue'
import { IContainer } from './interface'
import { basicLayout } from './tools/register'
import { DROP_LAYOUT_EL, EVENT_NAME_LIST, LABEL_NAME_LIST} from './tools/const'
import './css/style.css'
import deepcopy from 'deepcopy'
import UEI from "../../json-edit/src/use/useEditInfo";
import { disposeConfig } from "./tools/dispose";
const isDev = process.env.NODE_ENV === "development"
export default defineComponent({
  name: 'KJsonParse',
  props: {
    // 是否在编辑状态
    editor: {
      type: Boolean,
      default: () => false
    },
    // 布局容器
    layout: {
      type: Object as PropType<IContainer>,
      default: () => basicLayout
    },
    // 本地模拟数据
    mock: {
      type: Object,
      default: () => ({})
    }
  },

  setup(_props, _ctx) {
    const _refs: {[prop:string]: any} = {}
    const _con = disposeConfig._con
    // () => { console.log('props',_props, 'ctx', _ctx, '_con', _con, '_refs',_refs)}
    // 解析单个属性
    function evalAttr(key: string, attr: string | undefined | null, config: {[prop:string]:any}|undefined) {
      const _data = _props.mock  
      const _for = config && config._for ? config._for : null
      const _forIndex = config && (config._forIndex || config._forIndex === 0) ? config._forIndex : null
      // 处理事件属性"onClick/onMousedown/onMouseup..."
      if (key.includes('onUpdate:') || EVENT_NAME_LIST.includes(key)) {
        if (attr) {
          try {
            return eval(attr)
          } catch (error) {
            isDev && console.warn(`解析事件"${key}"未通过。事件内容:${attr}。可能是内部引用的变量不存在。`)
          }
        } else {
          isDev && console.info(`${key}事件value不能为空`)
        }
        return null
      }
      if (typeof attr === 'string' && /^\{.+\}$/.test(attr)) {
        if (key === 'style'){
          try {
            return eval(`() =>(${attr})`)()
          } catch (err) {
            isDev && console.warn(`解析样式"${key}"未通过。样式内容${attr}。可能是内部引用的变量不存在。`)
          }
        } else {
          try {
            return eval(attr.slice(1, attr.length - 1))
          } catch (err) {
            isDev && console.warn(`解析属性"${key}"未通过。属性内容${attr}。可能是内部引用的变量不存在。`)
          }
        }
      } else {
        if (key === 'vif'){
          if([null, undefined, ''].includes(attr) || (attr && attr.trim() === '')) return true
        }
      }
      return attr
    }

    // 解析属性对象
    function evalAttrs(attrObj: {[prop:string]:any}, config: {[prop:string]:any}|undefined) {
      const _data = _props.mock
      const _for = config && config._for ? config._for : null
      const _forIndex = config && (config._forIndex || config._forIndex === 0) ? config._forIndex : null
      if (toString.call(attrObj) !== '[object Object]') return {}
      const tempObj: { [prop: string]: string } = {}
      Object.keys(attrObj).forEach(item => {
        ;(tempObj as any)[item] = evalAttr(item, (attrObj as any)[item], config)
      })
      // 单独处理styleConfig
      const styleConfig = { ...(tempObj.styleConfig as any) } as any
      if (toString.call(styleConfig) === '[object Object]' && Object.keys(styleConfig).length) {
        let configStr = ''
        Object.keys(styleConfig).forEach(key => {
          if (['height', 'width', 'left', 'top', 'font-size'].includes(key) && parseFloat(styleConfig[key] + '') == styleConfig[key]) {
            styleConfig[key] = `${(styleConfig[key] + '').trim()}px`
          }
          configStr += `${key}: ${styleConfig[key]};`
        })
        if (tempObj.style) {
          if (typeof tempObj.style === 'object' && toString.call(tempObj.style) === '[object Object]') {
            tempObj.style = { ...styleConfig, ...(tempObj.style as any) }
          } else if (typeof tempObj.style === 'string') {
            tempObj.style = configStr + tempObj.style
          }
        } else {
          tempObj.style = configStr
        }
      }
      delete tempObj.styleConfig
      return tempObj
    }

    // 解析for循环
    function parseFor(layoutObj: IContainer, vfor: IContainer[]) {
      const { tag = 'div', text = '', children = null, vif, ...args } = layoutObj
      if (_props.editor && vfor.length) {
        // 编辑环境下不能复制多个
        return parseEle(layoutObj, { _for: vfor[0], _forIndex: 0 })
      }
      const resChildren = (vfor as any[]).map((_for, _forIndex) => {
        // 循环元素不可拖拽
        return parseEle({ tag, text, children, vif, ...args, vfor: undefined }, { _for, _forIndex })
      })
      return createVNode('div', { iscontainer: false, isroot: false }, resChildren)
    }

    // 解析layout成虚拟dom
    function parseEle(layoutObj: IContainer, config?: any): any {
      let { tag = 'div', text = '', children = null, vfor = null, vif = null,styleConfig = {}, attrsConfig, eventConfig, ...args } = layoutObj
      delete args.xrelative
      delete args.yrelative
      // 处理”v-model“双向绑定
      let vModel = args['vmodel'] || args['v-model']
      if (vModel) {
        delete args['v-model']
        delete args['vmodel']
        args['value'] = vModel
      }
      if (!LABEL_NAME_LIST.includes(tag)) {
        try {
          tag = resolveComponent(tag) as any
        } catch (error) {
          isDev && console.warn(`解析自定义组件出错：${tag}`)
        }
      }
      if (!_props.editor && args.isroot) {
        args.className = 'json-root' // 非编辑环境下，根元素添加类名
      }
      if (vfor && !config) {
        if (/^\{.+\}$/.test(vfor)) {
          vfor = evalAttr('vfor', vfor, config)
        }
        if (Array.isArray(vfor)) {
          return parseFor(layoutObj, vfor)
        } else {
          return null
        }
      } else {
        const evalText = evalAttr('text', text, config)
        const evalIf = evalAttr('vif', vif, config)
        let evalArgs = evalAttrs({ ...args, styleConfig }, config)
        if (!evalIf && !_props.editor) return null // 真实环境vif才会导致元素消失
        let resChild: any = null
        if (evalText && !Array.isArray(children)) {
          resChild = evalText
        } else if (Array.isArray(children)) {
          resChild = (children as IContainer[]).map(child => parseEle(child, config) )
          if (evalText) resChild.unshift(createTextVNode(evalText))
        }
        // 开始渲染元素，挂载属性-------------------------------------------------
        const vnodeResult:VNode = createVNode(tag, evalArgs, typeof tag === 'object'? { default: () => resChild } :resChild)
        nextTick(() => {
          if (vnodeResult && vnodeResult.el) {
            vnodeResult.el[DROP_LAYOUT_EL] = layoutObj
            if(layoutObj.ref) {
              _refs[layoutObj.ref] = vnodeResult.el
            }
            if(_props.editor) {
              UEI.layoutAndDocumentMap.set(layoutObj, vnodeResult.el)
            }
            // 编辑环境如果不可见设置透明度
            if(_props.editor) {
              if (!evalIf) {
                vnodeResult.el.style.display = 'none'
              } else {
                vnodeResult.el.style.display = 'block'
              }
            }
          }
        })
        return vnodeResult
      }
    }
    return () => {
      let tempLayout = _props.layout
      if(toString.call(tempLayout) !== '[object Object]') {
        tempLayout = deepcopy(basicLayout)
      } else {
        if(!tempLayout.isroot) tempLayout.isroot = true
      }
      return parseEle(tempLayout)
    }
  }
})
